import { render, staticRenderFns } from "./EmailVerifiedCallback.vue?vue&type=template&id=4d1aeb08&"
import script from "./EmailVerifiedCallback.vue?vue&type=script&lang=js&"
export * from "./EmailVerifiedCallback.vue?vue&type=script&lang=js&"
import style0 from "./EmailVerifiedCallback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports